"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var oidc_client_1 = require("oidc-client");
function addQueryParam(requestUrl, name, value) {
    var url = requestUrl;
    if (url.indexOf('?') < 0) {
        url += '?';
    }
    if (url[url.length - 1] !== '?') {
        url += '&';
    }
    url += encodeURIComponent(name);
    url += '=';
    url += encodeURIComponent(value);
    return url;
}
var UserManagerExternal = /** @class */ (function (_super) {
    __extends(UserManagerExternal, _super);
    function UserManagerExternal(settings) {
        if (settings === void 0) { settings = {}; }
        var _this = _super.call(this, settings) || this;
        _this.settings.iframe_post_logout_redirect_uri = settings.iframe_post_logout_redirect_uri;
        return _this;
    }
    UserManagerExternal.prototype.signoutIframe = function (args) {
        if (args === void 0) { args = {}; }
        /* eslint-disable no-underscore-dangle, no-param-reassign */
        oidc_client_1.Log.debug('UserManagerExternal.signoutIframe');
        var url = args.post_logout_redirect_uri ||
            this.settings.iframe_post_logout_redirect_uri ||
            this.settings.post_logout_redirect_uri;
        if (!url) {
            oidc_client_1.Log.error('No post_logout_redirect_uri configured');
            return Promise.reject(new Error('No post_logout_redirect_uri configured'));
        }
        args.post_logout_redirect_uri = url;
        args.display = 'none';
        return this._signout(args, this._iframeNavigator, {
            startUrl: url,
            silentRequestTimeout: args.silentRequestTimeout || this.settings.silentRequestTimeout,
        }).then(function () {
            oidc_client_1.Log.info('signoutIframe successful');
        });
        /* eslint-enable no-underscore-dangle, no-param-reassign */
    };
    UserManagerExternal.prototype.signoutIframeCallback = function (url) {
        /* eslint-disable no-underscore-dangle */
        oidc_client_1.Log.debug('UserManagerExternal.signoutIframeCallback');
        return this._iframeNavigator.callback(url).then(function () {
            oidc_client_1.Log.info('signoutIframeCallback successful');
        });
        /* eslint-enable no-underscore-dangle */
    };
    UserManagerExternal.prototype.createSignoutRequest = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var state = args && args[0] && args[0].state;
        if (state && state.extraQueryParams) {
            return _super.prototype.createSignoutRequest.apply(this, args).then(function (request) {
                var customRequest = request;
                var extraQueryParams = state.extraQueryParams || {};
                var url = request.url;
                Object.keys(extraQueryParams).forEach(function (key) {
                    url = addQueryParam(url, key, extraQueryParams[key]);
                });
                customRequest.url = url;
                return customRequest;
            });
        }
        return _super.prototype.createSignoutRequest.apply(this, args);
    };
    return UserManagerExternal;
}(oidc_client_1.UserManager));
exports.default = UserManagerExternal;
//# sourceMappingURL=UserManagerExternal.js.map